import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Row,
  Col,
  Table,
  Alert,
  Collapse,
  Label,
  Badge,
  Input,
} from "reactstrap";
import Papa from "papaparse";
import Steps from "../../../components/Steps/Steps";
import Select from "react-select/lib/Select";
import { BiCheckCircle, BiXCircle } from "react-icons/bi";
import { uploadUsersForTrivvy } from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import Checkbox from "rc-checkbox";
import { validateEmail } from "../../../utils/validations";

export default function UploadUsersModal({
  open,
  onClose,
  uploadSuccess,
  oldUsers = [],
}) {
  const [usersList, setUsersList] = useState([]);
  const [invalidUsersList, setInvalidUsersList] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [file, setFile] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [fields, setFields] = useState([]);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [inviteViaEmail, setInviteViaEmail] = useState(false);
  const [inviteViaSMS, setInviteViaSMS] = useState(false);
  const [notifyNewUsers, setNotifyNewUsers] = useState(false);
  const [notifyAllUsers, setNotifyAllUsers] = useState(false);
  const [phoneValuesPresent, setPhoneValuesPresent] = useState(false);
  const [uploadType, setUploadType] = useState("uploadOnly");
  const [uploadOnly, setUploadOnly] = useState(true);
  const [uploadAndUpdate, setUploadAndUpdate] = useState(false);
  const [deactivateOldNonCsvUsers, setDeactivateOldNonCsvUsers] = useState(
    false
  );

  // let phoneValuesPresent =
  //   usersList && usersList.length
  //     ? usersList.filter((x) => x.mobileNumber).length > 0
  //     : false;

  const emailValuesPresent =
    usersList && usersList.length
      ? usersList.filter((x) => x.email).length > 0
      : false;

  const [notificationType, setNotificationType] = useState("");

  const fieldOptions = [
    { label: "First Name", value: "firstName" },
    { label: "Last Name", value: "lastName" },
    { label: "Email", value: "email" },
    { label: "Department/Position", value: "departmentPosition" },
    { label: "Employee ID", value: "employeeId" },
    { label: "Mobile Number", value: "mobileNumber" },
  ];
  const [matchedKeys, setmatchedKeys] = useState([]);

  const handleCsvParseComplete = (result, file) => {
    const fields = result.meta.fields;
    const data = result.data;

    const newData = [];

    for (const field of fields) {
      newData.push({
        selectedKey: "",
        fieldName: field,
        data: [],
      });
    }

    console.log("fields---", fields);
    if (fields.indexOf("phone") > -1) {
      setPhoneValuesPresent(true);
    }

    for (const item of data) {
      for (const field of fields) {
        const indx = newData.findIndex((x) => x.fieldName == field);
        if (indx >= 0) {
          newData[indx].data.push(item[field]);
        } else {
          console.log("no fielddd");
        }
      }
    }

    setRowData(newData);
  };

  // console.log(oldUsers);

  const handleFileUpload = (e) => {
    const csvFile = e.target.files[0];
    setUsersList([]);
    setInvalidUsersList([]);
    setRowData([]);
    setmatchedKeys([]);
    setFile(csvFile);
    Papa.parse(csvFile, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: "greedy",
      complete: handleCsvParseComplete,
    });
  };

  const mapTableData = () => {
    const data = [...rowData].filter((x) =>
      [
        "firstName",
        "lastName",
        "email",
        "employeeId",
        "departmentPosition",
        "mobileNumber",
      ].includes(x.selectedKey)
    );

    const emailObj = data.find((x) => x.selectedKey == "email");
    const mobileNumberObj = data.find((x) => x.selectedKey == "mobileNumber");
    const firstNameObj = data.find((x) => x.selectedKey == "firstName");
    const lastNameObj = data.find((x) => x.selectedKey == "lastName");
    const employeeIdObj = data.find((x) => x.selectedKey == "employeeId");
    const departmentPositionObj = data.find(
      (x) => x.selectedKey == "departmentPosition"
    );

    const array = emailObj.data.map((item, index) => {
      return {
        firstName: firstNameObj ? firstNameObj.data[index] : undefined,
        lastName: lastNameObj ? lastNameObj.data[index] : undefined,
        email: item && item.length ? item.trim() : item,
        mobileNumber: mobileNumberObj
          ? mobileNumberObj.data[index]
            ? mobileNumberObj.data[index].toString()
            : ""
          : undefined,
        role: "User",
        employeeId: employeeIdObj
          ? employeeIdObj.data[index]
            ? employeeIdObj.data[index].toString()
            : ""
          : undefined,
        departmentPosition: departmentPositionObj
          ? departmentPositionObj.data[index]
          : undefined,
      };
    });

    const cleanedData = array.filter(
      (x) => x.email && x.email.trim().length && validateEmail(x.email)
    );
    const invalidData = array.filter((x) =>
      x.email ? !validateEmail(x.email) : !x.email
    );

    setInvalidUsersList(invalidData);

    setUsersList(cleanedData);
  };

  const handleUploadUsers = () => {
    if (!file) {
      toastContainer("Please select a CSV file before uploading.", "error");
      return;
    }
      // Build payload object that backend will JSON.parse from fields.payload[0]
      const payload = {
        data: usersList,
        // Optional but useful for metadata model on backend
        columnNames: rowData.map(function (r) { return r.fieldName; }),
        matchedKeys: matchedKeys,
        inviteViaEmail: inviteViaEmail,
        inviteViaSMS: inviteViaSMS,
        notifyNewUsers: notifyNewUsers,
        notifyAllUsers: notifyAllUsers,
        uploadOnly: uploadOnly,
        uploadAndUpdate: uploadAndUpdate,
        deactivateOldNonCsvUsers: deactivateOldNonCsvUsers,
        // you can decide how you want to treat this; for now a simple flag
        isPhoneValid: !!phoneValuesPresent,
        // if you don’t have extra metadata yet, send empty array (backend default)
        allUsersMetaData: [],
        // if you don’t have date columns yet, send empty
        isDateResponse: [],
      };

      var formData = new FormData();
      formData.append("file", file); // this becomes files.file[0] on backend
      formData.append("payload", JSON.stringify(payload)); // this becomes fields.payload[0]

    axios
      .post(url.uploadUsersForTrivvyFromCsv,  formData, {
        // axios will set the proper multipart boundary when body is FormData
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((data) => {
        if (data.data.data.updateSuccess) {
          const existingEmails = data.data.data.existingEmails;

          let toastText =
            existingEmails && existingEmails.length > 0
              ? `All users info updated succesfully, except ${
                  existingEmails.length
                } of the following users already exists: ${existingEmails.join(
                  ", "
                )}.`
              : `All users uploaded successfully.`;

          toastContainer(toastText, "success");
        } else {
          const errorRes = data.data.data.errorRes;
          if (errorRes && errorRes.length) {
            let toastText =
              errorRes && errorRes.length > 0
                ? `All users info updated succesfully, except ${
                    errorRes.length
                  } of the following users already exists: ${errorRes.join(
                    ", "
                  )}.`
                : `All users uploaded successfully.`;
            toastContainer(toastText, "success");
          } else {
            toastContainer(
              "All users were uploaded and invited succesfully",
              "success"
            );
          }
        }
        uploadSuccess();

        onClose();
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errors.message &&
          err.response.data.errors.error &&
          (Array.isArray(err.response.data.errors.error) ||
            typeof err.response.data.errors.error == "string")
        ) {
          const first =
            typeof err.response.data.errors.error == "string"
              ? err.response.data.errors.error + " is "
              : err.response.data.errors.error.join(",");
          const message = first + " " + err.response.data.errors.message;
          toastContainer(message, "error");
        } else {
          toastContainer("Error occured while uploading users", "error");
        }
      });
  };

  const buttonDisabled = () => {
    let disabled = false;

    if (currentStep == 1) {
      console.log(file);
      if (!file) {
        disabled = true;
      }
    } else if (currentStep == 2) {
      if (!matchedKeys.includes("email")) {
        disabled = true;
      }
    } else if (currentStep == 3) {
      if (notifyAllUsers || notifyNewUsers) {
        if (inviteViaEmail || inviteViaSMS) {
        } else {
          disabled = true;
        }
      }
    }

    return disabled;
  };

  const getFieldNameFromKey = (key) => {
    const keyData = fieldOptions.find((x) => x.value == key);

    if (keyData) {
      return keyData.label;
    } else {
      return null;
    }
  };

  useEffect(() => {
    const currentKeys = rowData.map((x) => x.selectedKey);
    const matched = [...matchedKeys].filter((x) => currentKeys.includes(x));
    setmatchedKeys(matched);
  }, [rowData]);

  const newCount = () => {
    let count = 0;

    if (oldUsers && Array.isArray(oldUsers) && usersList.length) {
      for (const item of usersList) {
        if (item.email && oldUsers.includes(item.email.trim())) {
          count += 1;
        }
      }

      count = usersList.length - count;
    }

    return count;
  };

  const getWarningText = () => {
    let uploadCount = 0;
    let inviteCount = 0;
    let smsInvites = 0;
    let emailInvites = 0;
    const totalUsersToNotify = notifyAllUsers
      ? usersList.length
      : usersList.filter(
          (x) => !oldUsers.findIndex((y) => y.email == x.email.trim()) >= 0
        ).length;
    let isNewUsers = false;
    for (const user of usersList) {
      uploadCount += 1;

      const oldExists = oldUsers
        ? oldUsers.find((x) => x.email == user.email.trim())
        : false;

      const isNew = !oldExists;

      const isLoggedIn = oldExists ? oldExists.isPasswordChanged : false;

      if (inviteViaEmail || inviteViaSMS) {
        if (notifyNewUsers) {
          if (isNew) {
            if (inviteViaSMS && user.mobileNumber) {
              smsInvites += 1;
            }

            if (inviteViaEmail) {
              emailInvites += 1;
            }
          }
        } else if (notifyAllUsers) {
          if (!isLoggedIn) {
            if (inviteViaSMS && user.mobileNumber) {
              smsInvites += 1;
            }

            if (inviteViaEmail) {
              emailInvites += 1;
            }
          }
        }
      }
    }

    const isAllSMS = smsInvites == totalUsersToNotify;

    const isAllEmail = emailInvites == totalUsersToNotify;

    let buildText = `${uploadCount} user(s) will be uploaded.`;

    if (smsInvites > 0 || emailInvites > 0) {
      if (notifyNewUsers) {
        buildText += " Only new users will be notified:";
      } else {
        buildText += " All unactivated users will be notified:";
      }
    }

    if (smsInvites > 0) {
      buildText += ` ${isAllSMS ? "all" : smsInvites} will receive SMS text${
        emailInvites > 0 ? " and" : "."
      }`;
    }

    if (emailInvites > 0) {
      buildText += ` ${
        isAllEmail ? "all" : emailInvites
      } will receive an email.`;
    }

    return buildText;
  };

  const handleRadioChange = (e) => {
    setNotificationType(e.target.value);
    if (e.target.value === "notifyAllUsers") {
      setNotifyAllUsers(true);
      setNotifyNewUsers(false);
    } else if (e.target.value === "notifyNewUsers") {
      setNotifyAllUsers(false);
      setNotifyNewUsers(true);
    } else {
      setNotifyAllUsers(false);
      setNotifyNewUsers(false);
    }
  };

  const handleRadioChangeForUploadType = (e) => {
    setUploadType(e.target.value);
    if (e.target.value === "uploadOnly") {
      setUploadOnly(true);
      setUploadAndUpdate(false);
    } else if (e.target.value === "uploadAndUpdate") {
      setUploadOnly(false);
      setUploadAndUpdate(true);
    }
  };

  return (
    <Modal isOpen={open} className="trivvyUsersUpload-modal-container">
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Upload Users
      </ModalHeader>
      <ModalBody className="p-3 pb-0 trivvyUsersUpload">
        <Steps
          steps={["Upload File", "Match Columns", "Preview And Save"]}
          currentStep={currentStep}
        />

        {currentStep === 1 ? (
          <div className="">
            <h6 className="mb-3">{file ? file.name : ""}</h6>
            <div className="singleTaskUploadModalBtn">
              <label
                htmlFor="profile-pic-file-input"
                style={{ marginBottom: "0px" }}
              >
                <span
                  className={`actionsByStatus ${
                    1 == 1 ? "" : "singleTaskUpload"
                  } btn-info`}
                >
                  <span className="flaticon-upload create-trivia-upload-icon" />
                  Choose File
                </span>
                <small>(Only .csv files, maximum 20MB file size)</small>
              </label>
              <input
                id="profile-pic-file-input"
                onChange={handleFileUpload}
                type="file"
              />
            </div>

            <div style={{ fontSize: "12px", marginTop: "12px" }}>
              You can upload Email, First Name, Last Name, Employee Id,
              Department, Mobile Number.
            </div>

            <div
              style={{ fontSize: "12px", marginTop: "24px" }}
              className="text-danger"
            >
              Note* Email is compulsory field. The first row of your file should
              be the files headers/column names.
            </div>
          </div>
        ) : currentStep === 2 ? (
          <div>
            <div className="my-3">{matchedKeys.length} columns matched</div>
            <div className="data-mapping-table">
              <div className="data-mapping-table-upload-row">
                {rowData.map((row, index) => {
                  const matched = matchedKeys.includes(row.selectedKey);
                  return (
                    <div className="match-col-main-wrapper-col">
                      <div
                        className={`map-cols-header px-2 ${
                          matched ? "matched-sec-bg" : "unmatched-sec-bg"
                        }`}
                        style={{ height: "200px" }}
                      >
                        <div className="text-center font-weight-bold mb-2">
                          {getFieldNameFromKey(row.selectedKey)
                            ? getFieldNameFromKey(row.selectedKey)
                            : row.fieldName}
                        </div>
                        <Select
                          options={fieldOptions.map((x) => ({
                            ...x,
                            disabled: matchedKeys.includes(x.value),
                          }))}
                          value={row.selectedKey}
                          onChange={(val) => {
                            if (val && val.value) {
                              const value = val.value;

                              const matched = [...matchedKeys];

                              if (value == "mobileNumber") {
                                // setInviteViaSMS(false)
                                // phoneValuesPresent=false
                                setPhoneValuesPresent(true);
                              }

                              matched.push(value);
                              setmatchedKeys(matched);
                              const data = [...rowData];
                              const extsting = data.find(
                                (x) => x.selectedKey == value
                              );
                              if (extsting) {
                                toastContainer(
                                  "This column is already matched please unmatch previous & match again",
                                  "error"
                                );
                              } else {
                                data[index].selectedKey = value;

                                setRowData(data);
                              }
                            }
                          }}
                        />

                        <div className="text-center mt-4">
                          {matched ? (
                            <span className="matched-column-txt">
                              (matched column)
                            </span>
                          ) : (
                            <span className="unmatched-column-txt">
                              (unmatched column)
                            </span>
                          )}

                          {matched ? (
                            <div className="text-center mt10">
                              <i
                                className="material-icons"
                                style={{ color: "#1EC4B4", fontSize: "30px" }}
                              >
                                check_circle
                              </i>
                            </div>
                          ) : null}

                          {matched ? (
                            <div className="text-center mt10">
                              <span
                                className="text-danger cursor-pointer"
                                onClick={() => {
                                  const matched = [...matchedKeys].filter(
                                    (x) => x != row.selectedKey
                                  );

                                  console.log("row --- ", row);
                                  console.log("amtched --- ", matched);

                                  if (row.selectedKey == "mobileNumber") {
                                    // setInviteViaSMS(false)
                                    // phoneValuesPresent=false
                                    setPhoneValuesPresent(false);
                                    setInviteViaSMS(false);
                                  }

                                  setmatchedKeys(matched);

                                  const row_d = [...rowData];

                                  row_d[index].selectedKey = "";

                                  setRowData(row_d);
                                }}
                              >
                                Unmatch
                              </span>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="mt-3">
                        {row.data.map((x) => (
                          <div className="map-cols-data">{x}</div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ) : currentStep == 3 && usersList.length ? (
          <div>
            {invalidUsersList && invalidUsersList.length ? (
              <div>
                <Alert color="danger">
                  Your csv has some records for which email address isnt present
                  as Email address is mandatory.{" "}
                  <span
                    className="cursor-pointer font-weight-bold"
                    onClick={() => setCollapseOpen(!collapseOpen)}
                  >
                    {collapseOpen ? "Click to close" : "Click to view"}
                  </span>
                </Alert>

                <Collapse isOpen={collapseOpen}>
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "450px" }}
                  >
                    <Table className="mt-5">
                      <thead>
                        <tr>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email</th>
                          {usersList[0].hasOwnProperty("employeeId") ? (
                            <th>Employee ID</th>
                          ) : (
                            ""
                          )}
                          {usersList[0].hasOwnProperty("departmentPosition") ? (
                            <th>Department/Position</th>
                          ) : (
                            ""
                          )}
                          {usersList[0].hasOwnProperty("mobileNumber") ? (
                            <th>Mobile Number</th>
                          ) : (
                            ""
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {invalidUsersList.map((x) => (
                          <tr>
                            <td>{x.firstName}</td> <td>{x.lastName}</td>{" "}
                            <td>{x.email || "-"}</td>
                            {usersList[0].hasOwnProperty("employeeId") ? (
                              <td>{x.employeeId}</td>
                            ) : (
                              ""
                            )}
                            {usersList[0].hasOwnProperty(
                              "departmentPosition"
                            ) ? (
                              <td>{x.departmentPosition}</td>
                            ) : (
                              ""
                            )}
                            {usersList[0].hasOwnProperty("mobileNumber") ? (
                              <td>{x.mobileNumber}</td>
                            ) : (
                              ""
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Collapse>
              </div>
            ) : (
              ""
            )}

            {/* <div className="mt-4">
              <span style={{ color: "#ff4500" }}>
                {" "}
                <b>{usersList.length}</b> Total, <b>{newCount()}</b> new{" "}
              </span>
            </div> */}

            <div className="table-responsive" style={{ maxHeight: "450px" }}>
              <Table className="mt-2">
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    {usersList[0].hasOwnProperty("mobileNumber") &&
                    usersList[0].mobileNumber != undefined ? (
                      <th>Mobile Number</th>
                    ) : (
                      ""
                    )}
                    {usersList[0].hasOwnProperty("employeeId") &&
                    usersList[0].employeeId != undefined ? (
                      <th>Employee ID</th>
                    ) : (
                      ""
                    )}
                    {usersList[0].hasOwnProperty("departmentPosition") &&
                    usersList[0].departmentPosition != undefined ? (
                      <th>Department/Position</th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>

                {usersList.length ? (
                  <tbody>
                    {usersList.map((x) => (
                      <tr>
                        <td>{x.firstName}</td> <td>{x.lastName}</td>{" "}
                        <td style={{ position: "relative" }}>
                          {x.email}{" "}
                          {x.email &&
                          oldUsers.findIndex(
                            (y) => y.email == x.email.trim()
                          ) >= 0 ? (
                            ""
                          ) : (
                            <span className="new-user-upload-row-item-badge">
                              New
                            </span>
                          )}{" "}
                        </td>
                        {usersList[0].hasOwnProperty("mobileNumber") ? (
                          <td>{x.mobileNumber}</td>
                        ) : (
                          ""
                        )}
                        {usersList[0].hasOwnProperty("employeeId") ? (
                          <td>{x.employeeId}</td>
                        ) : (
                          ""
                        )}
                        {usersList[0].hasOwnProperty("departmentPosition") ? (
                          <td>{x.departmentPosition}</td>
                        ) : (
                          ""
                        )}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  "No data exista"
                )}
              </Table>
            </div>
          </div>
        ) : null}

        {currentStep == 3 && (
          <div className="py-2 mt-3 d-flex align-items-center uploasSettingBorder">
            <h6 className="">Notify: </h6>

            <span>
              <label className={"ml-2"}>New users only</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="notification"
                value="notifyNewUsers"
                checked={notificationType === "notifyNewUsers"}
                className="ml-0"
                onChange={handleRadioChange}
              />
            </span>

            <span>
              <label className={"ml-4"}>All users (not activated yet)</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="notification"
                value="notifyAllUsers"
                checked={notificationType === "notifyAllUsers"}
                className="ml-0"
                onChange={handleRadioChange}
              />
            </span>

            <span>
              <label className={"ml-4"}>Do not notify</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="notification"
                value=""
                checked={notificationType === ""}
                className="ml-0"
                onChange={handleRadioChange}
              />
            </span>
          </div>
        )}

        {currentStep == 3 && (
          <div className="py-2 mt-3 d-flex align-items-center uploasSettingBorder">
            <h6 className="">Upload settings: </h6>

            <span>
              <label className={"ml-2"}>Upload only</label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="uploas"
                value="uploadOnly"
                checked={uploadType === "uploadOnly"}
                className="ml-0"
                onChange={handleRadioChangeForUploadType}
              />
            </span>

            <span>
              <label className={"ml-4 mb-0"}>
                Upload and update if user exists
              </label>{" "}
              <Input
                style={{ position: "relative", marginTop: "0px" }}
                type="radio"
                name="upload"
                value="uploadAndUpdate"
                checked={uploadType === "uploadAndUpdate"}
                className="ml-0"
                onChange={handleRadioChangeForUploadType}
              />
              <br />
              <small className="text-secondary ml-4 font-11px">
                (previous user info will be overwritten)
              </small>
            </span>
          </div>
        )}

        {currentStep == 3 && (notifyAllUsers || notifyNewUsers) && (
          <div className="py-2 d-flex align-items-center uploasSettingBorder">
            <h6>Via: </h6>

            <span>
              <Label className={"ml-2"}>Email</Label>{" "}
              <Checkbox
                className="ml-0"
                checked={inviteViaEmail}
                disabled={!emailValuesPresent}
                onChange={(e) => setInviteViaEmail(e.target.checked)}
              />
            </span>

            <span
              style={{
                opacity: phoneValuesPresent ? "1" : "0.5",
              }}
            >
              <Label className={"ml-4"}>SMS text</Label>{" "}
              <Checkbox
                className="ml-0"
                disabled={!phoneValuesPresent}
                checked={phoneValuesPresent ? inviteViaSMS : false}
                onChange={(e) => setInviteViaSMS(e.target.checked)}
              />
            </span>

            {!inviteViaEmail && !inviteViaSMS ? (
              <Label className="notify-via-msg">(select at least one) </Label>
            ) : null}
          </div>
        )}

        {currentStep == 3 && (
          <div className="mt-4">
            <Checkbox
              checked={deactivateOldNonCsvUsers}
              onChange={(e) => setDeactivateOldNonCsvUsers(e.target.checked)}
            />{" "}
            <Label>
              Deactivate users if they do not exists in uploaded csv?
            </Label>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          style={{ height: "35px" }}
          className=""
          onClick={() => {
            if (currentStep == 1) {
              onClose();
            } else {
              setCurrentStep(currentStep - 1);
            }
          }}
        >
          {currentStep == 1 ? "Cancel" : "Back"}
        </Button>

        {currentStep == 3 && (
          <div className="uploadUserWarningText">{getWarningText()}</div>
        )}

        {/* <Button
          style={{ height: "35px" }}
          className="mr-3 ml-3"
          onClick={() => {
            if (currentStep == 1) {
              onClose();
            } else {
              setCurrentStep(currentStep - 1);
            }
          }}
        >
          {currentStep == 1 ? "Cancel" : "Go Back"}
        </Button> */}

        <Button
          className="trivia-action-button-main mr-0"
          style={{ height: "35px" }}
          disabled={buttonDisabled()}
          onClick={() => {
            if (currentStep == 1) {
              setCurrentStep(currentStep + 1);
            } else if (currentStep == 2) {
              mapTableData();
              setCurrentStep(currentStep + 1);
            } else {
              handleUploadUsers();
            }
          }}
          // color="success"
        >
          {currentStep == 3 ? "Upload" : "Continue"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
